<div class="competition-item container-fluid p-0" [class.show]="showDetails">
  <div class="title pl-4 pr-3" (click)="onToggle()">
    <span class="text">{{title}}</span>
    <span class="chevron p-2 align-self-center">
      <i class="icon icon-arrow-fwd text-secondary" aria-hidden="true"></i>
    </span>
  </div>

  <div class="content">
    <ng-content select=".content"></ng-content>
  </div>
</div>
  